import { CrmAddonGate } from '@/pages/crm/addon/AddonGate';
import { OfferViewPage } from '@/pages/crm/offers/view/OfferViewPage';
import { requireAnyPermission } from '@/lib/route-guards/permission-guard';
import { createFileRoute } from '@tanstack/react-router';

// Flat file (a sibling of $dealId.tsx) rather than a nested layout directory: the offer view is a
// leaf with no shared layout below it, so it keeps the deal detail children's flat-file naming.
function OfferViewRoute() {
	return (
		<CrmAddonGate>
			<OfferViewPage />
		</CrmAddonGate>
	);
}

export const Route = createFileRoute('/_authenticated/_app/crm/deals/$dealId_/offers/$versionId')({
	beforeLoad: ({ context }) =>
		requireAnyPermission({ context, anyOf: ['deals.read.own', 'deals.read.all'], redirectTo: '/dashboard' }),
	component: OfferViewRoute,
});
